import { useState } from 'react'

import { authenticateDev } from '../api/auth'
import type { AuthSession, UserRole } from '../api/types'
import { devOrgIdForRole, isDevMode } from '../config/devMode'

type DevModeBannerProps = {
  session: AuthSession
  devRole: UserRole
  onSessionChange: (session: AuthSession, role: UserRole) => void
  onRoleSwitch?: () => void
}

export const DevModeBanner = ({ session, devRole, onSessionChange, onRoleSwitch }: DevModeBannerProps) => {
  const [switching, setSwitching] = useState(false)

  if (!isDevMode) {
    return null
  }

  const handleRoleSwitch = async (role: UserRole) => {
    if (role === devRole || switching) {
      return
    }
    const organizationId = devOrgIdForRole(role)
    if (!organizationId) {
      return
    }

    setSwitching(true)
    const result = await authenticateDev('', null, {
      organizationId,
    })
    setSwitching(false)

    if (result.kind === 'linked') {
      onRoleSwitch?.()
      onSessionChange(result.session, role)
    }
  }

  return (
    <div className="dev-banner" role="status">
      <p className="dev-banner__title">Dev mode — чат без ЛК, ответ эхом от второй роли</p>
      <div className="dev-banner__roles" role="group" aria-label="Роль для отправки">
        <button
          type="button"
          className={devRole === 'buyer' ? 'dev-banner__role dev-banner__role--active' : 'dev-banner__role'}
          disabled={switching}
          onClick={() => void handleRoleSwitch('buyer')}
        >
          Покупатель
        </button>
        <button
          type="button"
          className={devRole === 'supplier' ? 'dev-banner__role dev-banner__role--active' : 'dev-banner__role'}
          disabled={switching}
          onClick={() => void handleRoleSwitch('supplier')}
        >
          Поставщик
        </button>
      </div>
      <p className="dev-banner__meta">org {session.organizationId}</p>
    </div>
  )
}
